import React, {createContext, useContext, useEffect, useState} from "react";
import {useFirestore} from "reactfire";
import Year from "../../database/models/Year";

const initialState: Year[] = [];

const YearContext = createContext<Year[]>(initialState);

interface IProps {
  children: any;
}

export const YearProvider = (props: IProps) => {
  const [state, setState] = useState(initialState);
  const store = useFirestore();

  useEffect(() => {
    return store
      .collection("years")
      .onSnapshot({}, (snapshot) => {
        snapshot
          .docChanges()
          .forEach((change) => {
            if (change.type === "added") {
              setState(prevState => {
                prevState.push({
                  id: change.doc.id,
                  appliedYear: change.doc.data().appliedYear,
                  startsAt: change.doc.data().startsAt?.toDate(),
                  endsAt: change.doc.data().endsAt?.toDate()
                });

                return Object.assign([], prevState);
              });
            }
            if (change.type === "modified") {
              setState(prevState => {
                prevState
                  .filter(ps => ps.id === change.doc.id)
                  .forEach(ps => {
                    ps.appliedYear = change.doc.data().appliedYear;
                    ps.startsAt = change.doc.data().startsAt?.toDate();
                    ps.endsAt = change.doc.data().endsAt?.toDate();
                  });

                return Object.assign([], prevState);
              });
            }
            if (change.type === "removed") {
              setState(prevState => {
                const filteredArray = prevState.filter(ps => ps.id !== change.doc.id);

                return Object.assign([], filteredArray);
              });
            }
          });
      });
  }, [store]);

  return (
    <YearContext.Provider
      value={{
        ...state,
      }}
    >
      {props.children}
    </YearContext.Provider>
  );
};

export const useYears = (): Year[] => useContext(YearContext);
